import { getServiceUrls } from "../services/serviceUrls";

export const getUrls = () => {
  const SERVICE_URL = getServiceUrls();
  return {
    PAYMENT_URL: `${SERVICE_URL.REACT_APP_PLUGNPAY_URL}`,
    PAYMENT_GATEWAY_ACCOUNT: `${SERVICE_URL.REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT}`,
    PAYMENT_RESPONSE_URL: `${SERVICE_URL.INVOICE_SERVICE}/webhook/payment/commercial-invoice`,

    EDIT_COMMERCIAL_FLIGHT_PLANS_PASSENGERS: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/passenger`,
    EDIT_COMMERCIAL_FLIGHT_PLANS_VEHICLES: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/vehicles`,

    //TRIP Services API
    SEARCH_AIRCRAFT: `${SERVICE_URL.TRIP_SERVICE}/aircraft-type/search-by-icao`,
    CREATE_COMMERCIAL_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans`;
    },
    CHECK_OVERTIME_FEE: `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/overtime`,
    GET_AVIATION_STACK_AIRLINES: `${SERVICE_URL.TRIP_SERVICE}/flight-data-source/airlines`,
    GET_AVIATION_STACK_FAILURE: `${SERVICE_URL.TRIP_SERVICE}/flight-data-source/failure`,
    BULK_UPDATE_INVOICES: `${SERVICE_URL.TRIP_SERVICE}/internal/commercial-flight-plans/bulk-update-for-invoices`,
    LIST_OF_AIRLINE: `${SERVICE_URL.TRIP_SERVICE}/commercial-airline`,
    LIST_OF_AIRCRAFT: `${SERVICE_URL.TRIP_SERVICE}/aircraft-type`,
    SEARCH_AIRLINE: `${SERVICE_URL.TRIP_SERVICE}/commercial-airline/search`,
    GET_AIRLINE_ME: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/commercial-airline`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-airline/me`;
    },
    SEARCH_COMMERCIAL_PROFILE: `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/search`,
    INVITE_COMMERCIAL_USER: `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/invite`,
    GET_COMMERCIAL_USER_PROFILE: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.FEE_SERVICE}/aa-profile/me`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/me`;
    },
    GET_HISTORIC_COMMERCIAL_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/historic`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/historic`;
    },
    FILTER_HISTORIC_COMMERCIAL_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/historic/filter`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/historic/filter`;
    },
    GET_COMMERCIAL_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/current`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/current`;
    },
    GET_COMMERCIAL_FUTURE_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/future`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/future`;
    },
    FILTER_COMMERCIAL_FUTURE_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/future/filter`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/future/filter`;
    },
    GET_COMMERCIAL_CURRENT_FLIGHT_PLANS_SUMMARY: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/current/snapshot`;
      }
    },
    FILTER_COMMERCIAL_CURRENT_FLIGHT_PLANS_SUMMARY: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/current/snapshot/filter`;
      }
    },
    FILTER_COMMERCIAL_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/current/filter`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/current/filter`;
    },
    SEARCH_FLIGHT_PLANS: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/search`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/search`;
    },
    GET_AIRLINE_ASSOCIATIONS: `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/association`,
    UPDATE_AIRLINE_ASSOCIATIONS: `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/association`,
    ADD_COMMERCIAL_ESCORT: `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/escort-service`,
    GET_AIRLINE_VENDOR_LEASE: (leaseId, page = 0, size = 10) =>
      `${SERVICE_URL.TRIP_SERVICE}/airline-vendor-lease/${leaseId}?page=${page}&size=${size}`,
    GET_PROFILE_ASSOCIATION: `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/association`,

    DELETE_AIRLINE_ASSOCIATIONS: (associationId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/association/${associationId}/delete`,
    GET_COMMERCIAL_ESCORT: (planId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}/escort-service`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/escort-service`;
    },
    GET_AIRCRAFT_DETAILS: (aircraftTypeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/aircraft-type/${aircraftTypeId}`,
    GET_COMMERCIAL_FLIGHT_PLAN: (id, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${id}`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${id}/details`;
    },
    EDIT_COMMERCIAL_FLIGHT_PLANS: (planId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}`;
    },
    CANCEL_COMMERCIAL_FLIGHT_PLANS: (planId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}/cancel`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/cancel`;
    },
    APPROVE_AIRLINE_COMMERCIAL_FLIGHT_PLANS: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/airline-approval`,
    CHECK_AIRLINE_APPROVAL_DISPUTE: (
      planId,
      raiseDispute = false,
      disputeReason = ""
    ) => {
      let url = `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/airline-approval?raiseDispute=${raiseDispute}`;
      if (disputeReason && disputeReason.trim()) {
        url += `&disputeReason=${encodeURIComponent(disputeReason.trim())}`;
      }
      return url;
    },
    APPROVE_AA_COMMERCIAL_FLIGHT_PLANS: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}/aa-approval`,
    APPROVE_COMMERCIAL_FLIGHT_PLANS: (planId, apiType) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}/${apiType}`,
    GET_COMMERCIAL_FLIGHT_PLAN_FEE: (planId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${planId}/fee`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/fee`;
    },
    GET_COMMERCIAL_FLIGHT_PLAN_APPROVALS: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/approval`,
    GET_AVIATION_STACK_DATA: (airlineId) =>
      `${SERVICE_URL.TRIP_SERVICE}/flight-data-source/airline/${airlineId}`,
    GET_INVOICE_DETAILS: (flightPlanId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${flightPlanId}/details`,
    //USER Services API
    GET_COUNTRIES_LIST: `${SERVICE_URL.USER_SERVICE}/country`,
    GET_STATES_CITY_LIST: (id) =>
      `${SERVICE_URL.USER_SERVICE}/country/${id}/state-city`,

    //FEE Services API
    LIST_OF_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport`,
    GET_AA_ROLES: `${SERVICE_URL.FEE_SERVICE}/role`,
    GET_AIRPORT_BY_ID: (airportId) =>
      `${SERVICE_URL.FEE_SERVICE}/airport/${airportId}`,
    SEARCH_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport/search`,

    //INVOICE Services API
    GET_INVOICES: (airlineId) =>
      `${SERVICE_URL.INVOICE_SERVICE}/commercial-invoice/${airlineId}`,
    ADD_DEVICE_TOKEN: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.FEE_SERVICE}/aa-profile/add-device-token`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/add-device-token`;
    },
    REMOVE_DEVICE_TOKEN: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.FEE_SERVICE}/aa-profile/remove-device-token`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-profile/remove-device-token`;
    },
    GET_ESCORT_COMMERCIAL_FLIGHT_PLANS: `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/escort-cfp`,
    GET_ESCORT_DETAILS: (flightPlanId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${flightPlanId}/escort-service`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${flightPlanId}/escort-service`;
    },
    GET_OFFICERS_BY_AIRPORT: `${SERVICE_URL.TRIP_SERVICE}/officers/airport`,
    UPDATE_ESCORT_OFFICERS: (flightPlanId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${flightPlanId}/escort-officer`,
    APPROVE_ESCORT_SERVICE: (flightPlanId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${flightPlanId}/approve-escort`,
    REJECT_ESCORT_SERVICE: (flightPlanId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${flightPlanId}/reject-escort`,
    DELETE_ESCORT_SERVICE: (flightPlanId, isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-commercial-flight-plan/${flightPlanId}/escort-service`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${flightPlanId}/escort-service`;
    },
    WIRE_TRANSFER_PAYMENT: `${SERVICE_URL.INVOICE_SERVICE}/invoice-payment/commercial-wire-transfer`,
    GET_IATA_INVOICES: (airlineId) =>
      `${SERVICE_URL.INVOICE_SERVICE}/iata-file/airline/${airlineId}`,
    GET_IATA_INVOICES_BILLING_BREAKDOWN: (billingDocument) =>
      `${SERVICE_URL.INVOICE_SERVICE}/iata-file/document/${billingDocument}`,
    GET_IATA_INVOICES_FLIGHTS: (billingDocument) =>
      `${SERVICE_URL.INVOICE_SERVICE}/iata-file/flights/${billingDocument}`,

    // Export invoice details
    EXPORT_COMMERCIAL_INVOICE_DETAILS: `${SERVICE_URL.TRIP_SERVICE}/commercial-invoice/airline/export-invoice-details`,
    EXPORT_VENDOR_LEASE_INVOICE_DETAILS: `${SERVICE_URL.TRIP_SERVICE}/airline-vendor-lease/airline/export-invoice-details`,

    //Messaging-Services API
    GET_NOTIFICATIONS_UNREAD_COUNT: `${SERVICE_URL.MESSAGING_SERVICE}/notifications/unread-count`,
    GET_All_NOTIFICATIONS: `${SERVICE_URL.MESSAGING_SERVICE}/notifications`,
    READ_ALL_NOTIFICATIONS: `${SERVICE_URL.MESSAGING_SERVICE}/notifications/read-all`,
    READ_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/read`,
    UNREAD_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/unread`,
    DELETE_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}`,
    GET_COMMERCIAL_FLIGHT_PLANS_INVOICE: (lineItemId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-invoice-line-item/${lineItemId}/cfp-by-ids`,
    GET_BANK_CONFIG: (env) =>
      `${SERVICE_URL.CONFIG_SERVICE}/bank-config/${env === "staging" ? "dev" : env
      }`,
    GET_AIRLINE_BY_ID: (airlineId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-airline/${airlineId}`,
    GET_CONCESSION_FEE: (AAUser) => {
      if (AAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-airline-vendor-lease`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/airline-vendor-lease`;
    },
    UPDATE_AIRLINE_PASSENGER_COUNT: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/edit-passenger-count`,
    UPDATE_DISPUTE_PASSENGER_COUNT: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/cfp-dispute/${planId}`,
    SEARCH_SCANNED_PASSENGERS: (planId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-flight-plans/${planId}/scanned-passengers/search`,

    GET_PASSENGER_DISPUTE: (isAAUser) => {
      if (isAAUser) {
        return `${SERVICE_URL.TRIP_SERVICE}/review-cfp-dispute`;
      }
      return `${SERVICE_URL.TRIP_SERVICE}/cfp-dispute`;
    },
    REJECT_DISPUTE: (disputeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/cfp-dispute/${disputeId}/reject`,
    ACCEPT_DISPUTE: (disputeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/cfp-dispute/${disputeId}/accept`,

    // Configuration Service API
    GET_CONFIG: (profile) => `${SERVICE_URL.CONFIG_SERVICE}/config/${profile}`,
    ACCEPT_AA_PASSENGER_COUNT: (disputeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-cfp-dispute/${disputeId}/accept-aa-passenger-count`,
    ACCEPT_AIRLINE_PASSENGER_COUNT: (disputeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-cfp-dispute/${disputeId}/accept-airline-passenger-count`,
    DOWNLOAD_VAT_COMPLIANT_INVOICE: (dynamicsInvoiceId) =>
      `${SERVICE_URL.INVOICE_SERVICE}/commercial-invoice/vat-complaint-invoice?dynamicsInvoiceId=${dynamicsInvoiceId}`,
  };
};
